import React from 'react'
import { MaterialIconRef } from 'src/components/framework/icons/material-icon'

export const IconsBundle: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={{ display: 'none' }}>
      <g fill={'none'} fillRule={'evenodd'} id={MaterialIconRef.Locker}>
        <path d="M0 0h24v24H0z" />
        <path opacity=".87" d="M0 0h24v24H0z" />
        <path
          style={{ fill: 'var(--material-icon-fill)' }}
          d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0-10c1.66 0 3 1.34 3 3v2H9V6c0-1.66 1.34-3 3-3z"
        />
      </g>

      <g id={MaterialIconRef.Close}>
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" />
      </g>

      <g id={MaterialIconRef.Done}>
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
      </g>

      <g id={MaterialIconRef.ArrowRight}>
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z" />
      </g>

      <g id={MaterialIconRef.Search}>
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
      </g>
    </svg>
  )
}
